<template>
  <li v-show="usuario.autenticado" class="dropdown">
    <button
      id="usuarioMenu"
      data-test-id="button-menu-usuario"
      class="btn btn-primary dropdown-toggle navbar-brand"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="usuario-nome-completo">{{ usuario.nome }}</span>
      <span class="usuario-iniciais">{{ usuarioIniciais }}</span>
      <span class="caret" />
    </button>
    <ul class="dropdown-menu">
      <li>
        <div class="media">
          <div class="media-left">
            <span class="fa fa-user fa-4x" />
          </div>
          <div class="media-body media-middle">
            <h4 id="usuarioNome" class="media-heading">
              {{ usuario.nome }}
            </h4>
            <h6 id="usuarioPerfil" class="media-heading">
              {{ usuario.perfil }}
            </h6>
            <h5 id="usuarioEmail" class="media-heading">
              {{ usuario.email }}
            </h5>
          </div>
        </div>
      </li>
      <li class="menu-usuario-acoes">
        <button
          data-test-id="link-trocar-senha"
          type="button"
          class="btn btn-default"
          @click="redirecionarTrocarSenha()"
        >
          <span class="fa fa-key" />
          Trocar senha
        </button>
        <button
          id="botaoAtualizarAplicacao"
          data-test-id="button-atualizar-aplicacao"
          type="button"
          class="btn btn-default"
          :disabled="atualizandoAplicacao"
          @click="atualizarAplicacao()"
        >
          <span class="fa fa-refresh" />
          Atualizar aplicação
        </button>
      </li>
      <li class="menu-usuario-rodape">
        <button
          id="botaoLogout"
          data-test-id="button-logout"
          type="button"
          class="btn btn-danger"
          @click="logout()"
        >
          Sair
        </button>
      </li>
    </ul>
  </li>
</template>

<script>
import router from '@/router'
import Autenticacao from '@/servicos/Autenticacao'
import appStore from '@/stores'

const autenticacao = new Autenticacao()

export default {
  name: 'MenuUsuario',
  data() {
    return {
      atualizandoAplicacao: false,
    }
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
    usuarioIniciais() {
      const partesNome = ((this.usuario && this.usuario.nome) || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)

      if (!partesNome.length) {
        return ''
      }

      return partesNome.map((parte) => parte.charAt(0).toUpperCase()).join('')
    },
  },
  methods: {
    redirecionarTrocarSenha() {
      router.push('/usuario/nova-senha')
    },
    atualizarAplicacao() {
      if (this.atualizandoAplicacao) {
        return
      }

      this.atualizandoAplicacao = true
      window.location.reload()
    },
    logout() {
      autenticacao.logout()
      router.replace({ name: 'Login' })
    },
  },
}
</script>

<style scoped>
.media {
  width: 300px;
  padding: 2px;
  margin: 8px;
}

.dropdown-menu {
  min-width: 320px;
}

.menu-usuario-acoes {
  display: flex;
  gap: 8px;
}

.menu-usuario-acoes > button {
  width: 100%;
}

.menu-usuario-rodape {
  padding: 0;
  margin: 0;
}

.menu-usuario-rodape > .btn {
  width: 100%;
}

#usuarioMenu {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 220px;
}

.usuario-nome-completo,
.usuario-iniciais {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.usuario-iniciais {
  display: none;
}

.dropdown {
  flex: 0 0 auto;
}

@media (max-width: 767px) {
  #usuarioMenu {
    max-width: 88px;
    height: 40px;
    padding: 10px 8px;
    margin-right: 0;
    gap: 4px;
  }

  #menuUsuario > .dropdown {
    position: relative;
  }

  #menuUsuario > .dropdown > .dropdown-menu {
    position: absolute !important;
    top: 100%;
    right: 0 !important;
    left: auto !important;
    float: none !important;
    min-width: 280px;
    margin-top: 6px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  }

  #menuUsuario > .dropdown > .dropdown-menu::before,
  #menuUsuario > .dropdown > .dropdown-menu::after {
    display: none;
  }

  .usuario-nome-completo {
    display: none;
  }

  .usuario-iniciais {
    display: inline;
    max-width: 48px;
  }
}
</style>
